module.exports = "<ol class=\"breadcrumb\">\n    <li><a routerLink=\"{{ startRoute }}\" class=\"breadcrumb\"><span class=\"glyphicon glyphicon-home\"></span></a></li>\n    <li *ngFor=\"let breadcrumb of breadcrumbs; let last = last\">\n        <a *ngIf=\"!last\" [routerLink]=\"[breadcrumb.url, breadcrumb.params]\">{{ breadcrumb.label }}</a>\n        <span style=\"color:#777\" *ngIf=\"last\">{{ breadcrumb.label }}</span>\n    </li>\n</ol>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/breadcrumbs/breadcrumbs.component.html
// module id = ./src/app/shared/components/breadcrumbs/breadcrumbs.component.html
// module chunks = main